import { currentConfiguration } from "./Configuration";
import { createFeatureRouter, Router } from "./Router";

const MODELS_TO_RESPECT_STOCK: string[] = [
  //"iphone_16", "iphone_17", "iphone_air"
];

const isRestrictedModel = (modelName?: string) => {
  if (!modelName) return false;
  const modelNameLower = modelName.toLowerCase().replace(/\s+/g, "");

  return MODELS_TO_RESPECT_STOCK.some((model) =>
    modelNameLower.includes(model),
  );
};

export function createFeatureDecisions(router: Router) {
  return {
    ignoreOutOfStock: (modelName?: string) => {
      if (!router.isFeatureEnabled("ignoreOutOfStock")) {
        return false;
      }

      if (!modelName) {
        return true;
      }

      return !isRestrictedModel(modelName);
    },
    isRestrictedModel,
  };
}

export const features = createFeatureDecisions(
  createFeatureRouter(currentConfiguration),
);
